// Этап 23: общая шина событий «карта возвращена в руку».
//
// Эмитится из:
//   - livlife/evacuate.js#evacuateUnitToHand (Эвакуация, Заслон, Эв. модуль,
//     активка Арианы, триггер Арианы)
//   - global/ofitser_svyazi.js (Офицер связи 1-я линия — возврат союзника)
//   - global/actions.js global_act_evakuatsiya / global_act_zaslon (через evacuateUnitToHand)
//   - livlife/c1/actions-c1.js livlife_act_evakuatsionny_modul (через evacuateUnitToHand)
//
// API:
//   registerOnCardReturnedToHand(cardId, fn) — fn(state, observer, returnedCard).
//   fireCardReturnedToHand(state, returnedCard) — вызвать всех подписчиков.
//
// observer.ownerId должен совпадать со стороной события (то есть карта-наблюдатель
// и возвращённая — союзники). Молчание наблюдателя блокирует.

const _triggers = new Map();

export function registerOnCardReturnedToHand(cardId, fn) {
  if (typeof cardId !== 'string' || typeof fn !== 'function') return;
  _triggers.set(cardId, fn);
}

export function fireCardReturnedToHand(state, returnedCard) {
  if (!state?.players || !returnedCard) return;
  if (_triggers.size === 0) return;
  const ownerIdx = returnedCard.ownerId;
  if (ownerIdx == null) return;
  const owner = state.players[ownerIdx];
  if (!owner?.field) return;
  for (const row of owner.field) for (const u of row || []) {
    if (!u || !u.isAlive || !u.isAlive()) continue;
    if (u.current?.silenced) continue;
    const fn = _triggers.get(u.id);
    if (!fn) continue;
    try { fn(state, u, returnedCard); }
    catch (e) { console.warn(`[Корпы] card_returned_to_hand trigger ${u.id} упал:`, e); }
  }
}

export function _resetCardReturnedTriggersForTests() {
  _triggers.clear();
}
